module.exports = __webpack_public_path__ + "img/table_order_desc.821f2c58.svg";